const StatisticCard = ({ title, amount, image, icon }) => {
  return (
    <>
      <div className="cart-item flex items-center gap-4 rounded-xl bg-white border border-gray-200 px-5 py-4 shadow-sm hover:shadow-md hover:border-gray-300 hover:-translate-y-[1px] transition-all duration-200">
        <div className="h-12 w-12 rounded-full bg-blue-50 flex items-center justify-center">
          {icon ? (
            <span className="text-2xl">{icon}</span>
          ) : (
            <img src={image} alt="statistic" className="h-9 w-9 object-contain" />
          )}
        </div>
        <div className="flex-1 min-w-0">
          <p className="mb-1 text-xs font-medium text-gray-500 uppercase tracking-wide">
            {title}
          </p>
          <p className="text-xl font-semibold text-gray-900 truncate">
            {amount}
          </p>
        </div>
      </div>
    </>
  );
};

export default StatisticCard;
